<template>
  <div class="min-h-screen bg-gray-100 font-live pt-12 pb-20">
    <impersonation-alert></impersonation-alert>

    <testmode-ribbon :session="session"></testmode-ribbon>
    
    <nav class="fixed top-0 left-0 w-full bg-white shadow-sm z-50">
      <div class="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div class="flex justify-between items-center h-12 sm:h-16">
          <div class="flex items-center">
            <div class="flex-shrink-0 flex items-center">
              <a :href="route('control-panel.index')">
                <img
                  class="block sm:hidden h-8 sm:h-10 w-auto sharp-image"
                  src="/img/brandpreneurship-logo.png"
                  alt="brandpreneurship"
                />
                <img
                  class="hidden sm:block h-8 sm:h-10 w-auto sharp-image"
                  src="/img/brandpreneurship-logo.png"
                  alt="brandpreneurship"
                />
              </a>

              <viewport-width class="ml-4"></viewport-width>
            </div>
            <div class="ml-6 flex-col sm:mt-1">
              <p class="text-lg sm:text-xl font-light"></p>
            </div>
          </div>

          <simple-profile v-if="showProfile"></simple-profile>

          <div v-if="session" class="flex items-center">
            <qr-code-display :session="session"></qr-code-display>

            <user-counter
              v-if="session && session.current_phase == 'intro'"
              :session="session"
            ></user-counter>
            <answer-counter
              v-if="session && session.current_phase.startsWith('phase')"
              :session="session"
            ></answer-counter>
          </div>
        </div>
      </div>
    </nav>

    <div class="py-1">
      <main>
        <div class="max-w-7xl mx-auto sm:px-6 lg:px-8">
          <!-- Main: start -->

          <slot></slot>

          <!-- Main: end -->
        </div>
      </main>
    </div>

    <section
      class="fixed bottom-0 left-0 w-full text-center bg-white shadow-sm"
    >
      <slot name="footer"></slot>
    </section>

    <toast></toast>
  </div>
</template>

<script>
import QrCodeDisplay from '@/Pages/ControlPanel/Shared/QrCodeDisplay';
import UserCounter from '@/Pages/ControlPanel/Shared/UserCounter';
import AnswerCounter from '@/Pages/ControlPanel/Shared/AnswerCounter';
// import Profile from '@/Pages/ControlPanel/Shared/Profile';
import SimpleProfile from '@/Pages/ControlPanel/Shared/SimpleProfile';
import Toast from '@/Shared/Toast';
import ViewportWidth from '@/Shared/Helpers/ViewportWidth';
import ImpersonationAlert from '@/Shared/ImpersonationAlert';
import TestmodeRibbon from '@/Shared/TestmodeRibbon';

export default {
  components: {
    QrCodeDisplay,
    UserCounter,
    AnswerCounter,
    SimpleProfile,
    Toast,
    ViewportWidth,
    ImpersonationAlert,
    TestmodeRibbon,
  },

  props: {
    session: {
      required: false,
    },

    showProfile: {
      required: false,
      type: Boolean,
      default: false,
    },
  },
};
</script>
